import { SettingsApi } from './api';

export default async function fetchLeadTimesData({ accessToken }) {
	const res = await SettingsApi.get(`GetLeadTimes`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});
	return res?.data || [];
}
